import React from 'react';
import style from './style/About.module.css';
// import Loader from '../components/Loader';

const About = () => {
    return (
        <>
            <section className={style.owner}>
                <h1>About section</h1>
                <div className={style.box}>
                    <img src="https://source.unsplash.com/random/0" alt="myphoto" />
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Cupiditate repellendus quam consequuntur odio error, beatae mollitia laboriosam officiis praesentium quaerat quas veniam! A repudiandae tenetur facilis velit nisi laborum, unde beatae, suscipit iure dolorum quae molestias quia voluptas id adipisci repellendus esse? Exercitationem deserunt reprehenderit aliquam incidunt laborum necessitatibus tempore, officiis delectus unde, temporibus praesentium accusamus repellat minima placeat saepe.</p>
                </div>
                <div className={style.box}>
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Cupiditate repellendus quam consequuntur odio error, beatae mollitia laboriosam officiis praesentium quaerat quas veniam! A repudiandae tenetur facilis velit nisi laborum, unde beatae, suscipit iure dolorum quae molestias quia voluptas id adipisci repellendus esse? Exercitationem deserunt reprehenderit aliquam incidunt laborum necessitatibus tempore, officiis delectus unde, temporibus praesentium accusamus repellat minima placeat saepe.</p>
                    <img src="https://source.unsplash.com/random/10" alt="myphoto" />
                </div>
                
            </section>

            <section className={style.developer}>
                <h1>About Developer</h1>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi consequatur consequuntur iste ipsa laboriosam quas voluptas expedita neque adipisci tenetur, dolorem qui, quis optio et eos dolores dignissimos fugit? Quae, assumenda unde! Ea porro saepe tempore consectetur nihil vel? Illum labore odit mollitia cum expedita quaerat a adipisci recusandae eum consequuntur corporis nostrum blanditiis sint possimus, amet provident, quod quibusdam. Cumque nesciunt nemo culpa at odit qui autem nihil, perspiciatis doloribus, corrupti blanditiis! Soluta sequi magni expedita aperiam delectus maiores voluptatibus velit minima est quos! Animi tenetur voluptatum ipsum molestiae quisquam asperiores similique totam, velit, labore adipisci numquam earum odit!</p>
                <ul> Mycontacsts
                    <li>539659465345</li>
                    <li>veuvf@fbgs.gfbr.in</li>
                    <li>oert enr erbno 133423</li>
                </ul>
                <ol>some of projects
                    <a href="bfofborwe">owbfobefrbfiobforefbewrf</a> <br /><br />
                    <a href="bfofborwe">gttergdghtdhjnyjnhjtujgfghftghytrfhbtr</a> <br /><br />
                    <a href="bfofborwe">gfhtrhytryrtyrty</a> <br /><br />
                    <a href="bfofborwe">fghfghfghryurutyutyuuuyt <br /><br />utyuty</a> <br /><br />
                    <a href="bfofborwe">fhfyhrfhryuytujjtyuytuyytuytuytuytutyutyjhnghyjnyhgju</a> <br /><br />
                </ol>
            </section>
        </>
    )
}

export default About;
